import { FC, memo } from 'react'

import { AnimateCounter } from '@/components/atoms/AnimateCounter'

export interface GoldenBadgeLargeComponentProps {
  className?: string
  xp: number
  label?: string
}

const GoldenBadgeLargeComponent: FC<GoldenBadgeLargeComponentProps> = ({
  className = '',
  xp = 0,
  label = 'Gold',
}) => {
  return (
    <svg
      className={className}
      width="100%"
      height="100%"
      viewBox="0 0 224 214"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M170.099 42.3409L222.796 23.401C222.796 23.401 228.225 39.6361 216.028 44.1053C203.831 48.5746 188.015 54.3396 188.015 54.3396L170.099 42.3409Z"
        fill="url(#paint0_linear_1149_6563)"
      />
      <path
        d="M170.099 42.3409L222.796 23.401C222.796 23.401 228.225 39.6361 216.028 44.1053C203.831 48.5746 188.015 54.3396 188.015 54.3396L170.099 42.3409Z"
        fill="url(#paint1_linear_1149_6563)"
      />
      <path
        d="M171.617 42.6931L222.217 24.4578C222.217 24.4578 226.918 38.7722 216.258 43.2598C205.757 47.6831 187.779 53.5155 187.779 53.5155L171.614 42.6931H171.617Z"
        fill="url(#paint2_linear_1149_6563)"
      />
      <path
        d="M164.33 61.6147L217.025 42.6748C217.025 42.6748 222.453 58.9099 210.256 63.3791C198.059 67.8484 182.244 73.6134 182.244 73.6134L164.327 61.6147H164.33Z"
        fill="url(#paint3_linear_1149_6563)"
      />
      <path
        d="M165.845 61.967L216.445 43.7317C216.445 43.7317 221.146 58.0461 210.486 62.5337C199.985 66.957 182.007 72.7894 182.007 72.7894L165.842 61.967H165.845Z"
        fill="url(#paint4_linear_1149_6563)"
      />
      <path
        d="M156.685 82.5148L209.379 63.5749C209.379 63.5749 214.807 79.81 202.61 84.2793C190.414 88.7485 174.598 94.5135 174.598 94.5135L156.682 82.5148H156.685Z"
        fill="url(#paint5_linear_1149_6563)"
      />
      <path
        d="M158.203 82.8671L208.802 64.6317C208.802 64.6317 213.504 78.9462 202.844 83.4338C192.343 87.8571 174.365 93.6895 174.365 93.6895L158.2 82.8671H158.203Z"
        fill="url(#paint6_linear_1149_6563)"
      />
      <path
        d="M150.099 102.341L202.796 83.401C202.796 83.401 208.225 99.6361 196.028 104.105C183.831 108.575 168.015 114.34 168.015 114.34L150.099 102.341Z"
        fill="url(#paint7_linear_1149_6563)"
      />
      <path
        d="M151.617 102.693L202.217 84.4578C202.217 84.4578 206.918 98.7722 196.258 103.26C185.757 107.683 167.779 113.516 167.779 113.516L151.614 102.693H151.617Z"
        fill="url(#paint8_linear_1149_6563)"
      />
      <path
        d="M144.33 121.615L197.025 102.675C197.025 102.675 202.453 118.91 190.256 123.379C178.059 127.848 162.244 133.613 162.244 133.613L144.327 121.615H144.33Z"
        fill="url(#paint9_linear_1149_6563)"
      />
      <path
        d="M145.845 121.967L196.445 103.732C196.445 103.732 201.146 118.046 190.486 122.534C179.985 126.957 162.007 132.789 162.007 132.789L145.842 121.967H145.845Z"
        fill="url(#paint10_linear_1149_6563)"
      />
      <path
        d="M54.5831 42.3409L1.88562 23.401C1.88562 23.401 -3.54268 39.6361 8.65413 44.1053C20.8509 48.5746 36.6666 54.3396 36.6666 54.3396L54.5831 42.3409Z"
        fill="url(#paint11_linear_1149_6563)"
      />
      <path
        d="M54.5831 42.3409L1.88562 23.401C1.88562 23.401 -3.54268 39.6361 8.65413 44.1053C20.8509 48.5746 36.6666 54.3396 36.6666 54.3396L54.5831 42.3409Z"
        fill="url(#paint12_linear_1149_6563)"
      />
      <path
        d="M53.065 42.6931L2.46526 24.4578C2.46526 24.4578 -2.2362 38.7722 8.42412 43.2598C18.925 47.6831 36.9028 53.5155 36.9028 53.5155L53.0681 42.6931H53.065Z"
        fill="url(#paint13_linear_1149_6563)"
      />
      <path
        d="M60.3516 61.6147L7.65724 42.6748C7.65724 42.6748 2.22894 58.9099 14.4257 63.3791C26.6225 67.8484 42.4382 73.6134 42.4382 73.6134L60.3547 61.6147H60.3516Z"
        fill="url(#paint14_linear_1149_6563)"
      />
      <path
        d="M58.8366 61.967L8.23687 43.7317C8.23687 43.7317 3.5354 58.0461 14.1957 62.5337C24.6966 66.957 42.6744 72.7894 42.6744 72.7894L58.8397 61.967H58.8366Z"
        fill="url(#paint15_linear_1149_6563)"
      />
      <path
        d="M67.9972 82.5148L15.3029 63.5749C15.3029 63.5749 9.87457 79.81 22.0714 84.2793C34.2682 88.7485 50.0839 94.5135 50.0839 94.5135L68.0003 82.5148H67.9972Z"
        fill="url(#paint16_linear_1149_6563)"
      />
      <path
        d="M66.4792 82.8671L15.8794 64.6317C15.8794 64.6317 11.178 78.9462 21.8383 83.4338C32.3392 87.8571 50.3169 93.6895 50.3169 93.6895L66.4822 82.8671H66.4792Z"
        fill="url(#paint17_linear_1149_6563)"
      />
      <path
        d="M74.5831 102.341L21.8857 83.401C21.8857 83.401 16.4574 99.6361 28.6542 104.105C40.851 108.575 56.6666 114.34 56.6666 114.34L74.5831 102.341Z"
        fill="url(#paint18_linear_1149_6563)"
      />
      <path
        d="M73.065 102.693L22.4653 84.4578C22.4653 84.4578 17.7638 98.7722 28.4242 103.26C38.925 107.683 56.9028 113.516 56.9028 113.516L73.0681 102.693H73.065Z"
        fill="url(#paint19_linear_1149_6563)"
      />
      <path
        d="M80.3516 121.615L27.6573 102.675C27.6573 102.675 22.229 118.91 34.4258 123.379C46.6226 127.848 62.4382 133.613 62.4382 133.613L80.3547 121.615H80.3516Z"
        fill="url(#paint20_linear_1149_6563)"
      />
      <path
        d="M78.8366 121.967L28.2369 103.732C28.2369 103.732 23.5354 118.046 34.1958 122.534C44.6966 126.957 62.6744 132.789 62.6744 132.789L78.8397 121.967H78.8366Z"
        fill="url(#paint21_linear_1149_6563)"
      />
      <path
        d="M79.8988 182.65L59.7661 165.575L59.7368 94.2327L80.2207 94.2474L79.8988 182.65Z"
        fill="#FFEDAD"
      />
      <path
        d="M79.0209 180.338L60.8634 164.975L60.8341 96.3689L79.2989 96.4274L79.0209 180.338Z"
        fill="url(#paint22_linear_1149_6563)"
      />
      <path
        d="M143.838 183.44L163.956 166.365L164 95.0228L143.516 95.0521L143.838 183.44Z"
        fill="url(#paint23_linear_1149_6563)"
      />
      <path
        d="M144.716 181.143L162.873 165.765L162.903 97.159L144.438 97.2321L144.716 181.143Z"
        fill="url(#paint24_linear_1149_6563)"
      />
      <path
        d="M142.682 94.6131V95.7105L82.0204 95.6227V94.5253L142.682 94.6131Z"
        fill="url(#paint25_linear_1149_6563)"
      />
      <path
        d="M83.147 157.221L82.8105 184.552L110.756 202.68C111.225 203.075 111.912 203.075 112.395 202.695L141.76 184.26L141.365 154.587L111.4 166.848L83.147 157.221Z"
        fill="#FFEDAD"
      />
      <path
        d="M84.259 103.231L83.9664 183.66L110.859 201.393C111.254 201.729 111.81 201.729 112.205 201.393L140.048 183.718L139.756 103.29L84.2444 103.202L84.259 103.231Z"
        fill="url(#paint26_linear_1149_6563)"
      />
      <path
        d="M183.929 139.19L118.549 176.935C114.423 179.329 109.314 179.329 105.187 176.935L39.8079 139.19C35.6815 136.796 33.1271 132.384 33.1271 127.615V52.1067C33.1271 47.3372 35.6815 42.925 39.8079 40.5313L105.187 2.78628C109.314 0.392609 114.423 0.392609 118.549 2.78628L183.929 40.5313C188.055 42.925 190.609 47.3372 190.609 52.1067V127.597C190.609 132.366 188.055 136.779 183.929 139.172V139.19Z"
        fill="#FEEBFF"
      />
      <path
        d="M180.463 133.831L116.495 170.04C113.601 171.665 110.082 171.665 107.188 170.04L43.2199 133.831C40.6297 132.366 39.022 129.651 39.022 126.704V53.7859C39.022 50.8385 40.6297 48.1232 43.2199 46.6585L107.188 10.4675C110.082 8.84196 113.601 8.84196 116.495 10.4675L180.463 46.6763C183.053 48.1411 184.661 50.8563 184.661 53.8038V126.722C184.661 129.669 183.053 132.384 180.463 133.849V133.831Z"
        fill="#FFF1AC"
      />
      <path
        d="M112.5 180.5C109.838 180.5 107.063 178.4 104.687 177.024L41.0404 140.315C36.2888 137.564 33.3235 136.5 33.3235 131.016V53.5715C33.3235 48.0875 36.2709 42.9608 41.0404 40.2277L104.687 3.50086C109.439 0.767781 115.334 0.767781 120.085 3.50086L183.732 40.2098C188.484 42.9608 191.449 48.0697 191.449 53.5537V126.954C191.449 137 188.502 137.565 183.732 140.298L120.085 177.007C117.709 178.382 115.162 180.482 112.5 180.482V180.5ZM112.386 10.3246C111.261 10.3246 110.135 10.6104 109.117 11.1999L45.4884 47.9089C43.4698 49.07 42.2194 51.2315 42.2194 53.5715V126.972C42.2194 129.294 43.4698 131.473 45.4884 132.634L109.135 169.343C111.154 170.504 113.655 170.504 115.655 169.343L179.302 132.634C181.32 131.473 182.571 129.312 182.571 126.972V53.5715C182.571 51.2493 181.32 49.07 179.302 47.9089L115.655 11.1999C114.655 10.6283 113.529 10.3246 112.386 10.3246Z"
        fill="url(#paint27_linear_1149_6563)"
      />
      <path
        d="M181.753 134.037L116.728 170.884C114.102 172.372 110.878 172.372 108.253 170.884L43.2281 134.037C40.6024 132.549 39 129.804 39 126.846V53.1539C39 50.1768 40.6218 47.4317 43.2281 45.9625L108.272 9.1164C110.898 7.62787 114.122 7.62787 116.747 9.1164L181.772 45.9625C184.398 47.451 186 50.1961 186 53.1539V126.846C186 129.823 184.378 132.568 181.772 134.037H181.753Z"
        fill="#FEEBFF"
      />
      <path
        d="M182.259 133.291L114.251 172.536C113.167 173.155 111.833 173.155 110.749 172.536L42.7413 133.291C41.6578 132.672 41 131.512 41 130.254V51.7456C41 50.4884 41.6578 49.3472 42.7413 48.7089L110.749 9.46421C111.833 8.84526 113.167 8.84526 114.251 9.46421L182.259 48.7089C183.342 49.3279 184 50.4884 184 51.7456V130.254C184 131.512 183.342 132.653 182.259 133.291Z"
        fill="url(#paint28_linear_1149_6563)"
      />
      <g opacity="0.29">
        <path
          d="M112.5 175.98L40 133.715V49.2652L112.5 7L185 49.2652V133.735L112.5 176V175.98ZM47.3269 129.504L112.5 167.498L177.673 129.504V53.4553L112.5 15.4611L47.3269 53.4553V129.504Z"
          fill="url(#paint29_linear_1149_6563)"
        />
      </g>
      <path
        d="M112.5 178.96C111.647 178.96 110.813 178.741 110.059 178.303L38.421 136.487C36.9327 135.611 36 133.999 36 132.267V48.6732C36 46.9416 36.9327 45.3295 38.421 44.4537L110.059 2.65681C111.567 1.78106 113.433 1.78106 114.941 2.65681L186.579 44.4736C188.067 45.3494 189 46.9615 189 48.6931V132.327C189 134.058 188.067 135.671 186.579 136.546L114.941 178.343C114.187 178.781 113.333 179 112.5 179V178.96ZM44.0767 130.436L112.5 170.362L180.923 130.436V50.5242L112.5 10.5982L44.0767 50.5242V130.436Z"
        fill="url(#paint30_linear_1149_6563)"
      />
      <mask
        id="mask0_1149_6563"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="39"
        y="4"
        width="146"
        height="167"
      >
        <path
          d="M112.5 170.5C109.5 169 106.228 167.253 103.651 165.758L47.184 133.021C42.1346 130.094 39 124.673 39 118.879V53.1182C39 47.3238 42.1346 41.9029 47.184 38.9764L103.651 6.23885C108.804 3.25372 115.203 3.25372 120.352 6.23885L176.816 38.9764C181.865 41.9029 185 47.3238 185 53.1182V118.879C185 124.677 181.862 130.094 176.816 133.021L120.352 165.758C118.247 166.979 111.19 171.195 112.5 170.5Z"
          fill="#844B07"
        />
      </mask>
      <g mask="url(#mask0_1149_6563)">
        <g filter="url(#filter0_i_1149_6563)">
          <rect
            x="13"
            y="140"
            width="200"
            height="143"
            rx="71.5"
            fill="#D38B3B"
          />
        </g>
      </g>
      <path
        d="M98.0001 34.0485V53.3694L119.149 53.3069C120.748 53.3069 121.968 53.6921 122.926 55.035C122.961 55.0837 123.011 55.1205 123.049 55.1664C124.41 56.8531 126.134 57.5544 128.192 57.4138C128.645 57.3825 128.804 57.2005 128.797 56.7354L128.8 53.6884C128.815 53.1056 128.628 52.8694 128.066 52.8804L123.679 52.9154C123.679 52.9154 121.137 52.6442 119.937 51.2645L119.446 50.7406C118.268 49.4427 116.833 48.8122 115.15 48.8159C113.361 48.8195 111.571 48.8168 109.781 48.8177C107.067 48.8177 104.019 48.8067 101.305 48.8287V45.8396C105.231 45.8534 109.416 45.8497 113.343 45.8488C113.992 45.8488 114.544 46.0418 114.998 46.495C115.422 46.9178 115.871 47.3176 116.303 47.7349C117.42 48.814 118.776 49.4142 120.366 49.4345C122.964 49.4685 125.563 49.4391 128.16 49.4519C128.643 49.4538 128.807 49.2543 128.798 48.8223C128.782 47.9647 128.793 47.1062 128.791 46.2477C128.789 45.4848 128.779 45.4738 127.992 45.4738C124.316 45.4738 120.64 45.4719 116.963 45.4738C114.301 45.4756 114.615 45.6456 112.747 43.8183C111.368 42.469 109.748 41.7943 107.748 41.8504C105.71 41.9074 103.345 41.8568 101.304 41.8715V38.603H106.722C107.367 38.5928 107.884 38.8392 108.329 39.3043C108.853 39.853 109.354 40.4275 109.888 40.9652C110.891 41.9763 112.069 42.6234 113.458 42.6308C118.366 42.6565 123.274 42.6409 128.182 42.6537C128.631 42.6547 128.806 42.4699 128.798 41.9938C128.783 41.0195 128.792 40.0451 128.791 39.0708C128.791 38.1461 128.77 38.1222 127.924 38.1222C122.131 38.1222 116.337 38.1351 110.544 38.1176C107.364 38.1084 108.101 38.4789 105.844 36.0311C104.61 34.691 103.046 34.0503 101.307 34.0503L98.0001 34.0485Z"
        fill="#C67E1B"
      />
      <mask
        id="mask1_1149_6563"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="45"
        y="51"
        width="144"
        height="163"
      >
        <path
          d="M117.002 214C114.154 214 111.307 213.257 108.766 211.772L53.0719 179.234C48.0917 176.325 45 170.938 45 165.179V99.8187C45 94.0596 48.0917 88.6718 53.0719 85.7631L108.766 53.2252C113.848 50.2583 120.159 50.2583 125.238 53.2252L180.928 85.7631C185.908 88.6718 189 94.0596 189 99.8187V165.179C189 170.941 185.905 176.325 180.928 179.234L125.238 211.772C122.697 213.257 119.849 214 117.002 214Z"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask1_1149_6563)">
        <path
          d="M18.4518 88.5459L21.2371 24.972C22.1899 3.22431 39.9723 -13.9875 61.7395 -14.2308L161.01 -15.3406C189.588 -15.66 207.207 11.8 189.532 34.2584C176.978 50.2096 160.407 67.9469 139.275 85.3347C107.322 111.626 74.6349 121.256 49.9612 123.469C30.6947 125.197 17.6051 107.871 18.4518 88.5459Z"
          fill="url(#paint31_linear_1149_6563)"
        />
      </g>
      <text
        x="112"
        y="155"
        fontSize="13"
        fontWeight="bold"
        textAnchor="middle"
        fill="white"
      >
        {label}
      </text>
      <text
        x="112"
        y="105"
        fontSize="45"
        fontWeight="bold"
        textAnchor="middle"
        fill="#482A01"
      >
        <AnimateCounter start={0} end={xp} duration={1500} />
      </text>
      <path
        d="M102.145 130.351H105.01L107.778 125.904H107.866L110.652 130.351H113.676L109.571 124.014V123.979L113.729 117.669H110.767L108.086 122.239H107.989L105.291 117.669H102.171L106.179 123.935V123.962L102.145 130.351ZM115.161 130.351H117.816V126.352H120.259C122.931 126.352 124.715 124.63 124.715 122.019V122.002C124.715 119.391 122.931 117.669 120.259 117.669H115.161V130.351ZM119.609 119.769C121.129 119.769 122.026 120.569 122.026 122.01V122.028C122.026 123.469 121.129 124.278 119.609 124.278H117.816V119.769H119.609Z"
        fill="#C67E1B"
      />
      <defs>
        <filter
          id="filter0_i_1149_6563"
          x="13"
          y="140"
          width="210"
          height="145"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="15" dy="2" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1149_6563"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1149_6563"
          x1="223.998"
          y1="38.8703"
          x2="170.099"
          y2="38.8703"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C1C1C1" />
          <stop offset="0.45" stopColor="#9D9D9D" />
          <stop offset="0.82" stopColor="#8C8C8C" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1149_6563"
          x1="198.853"
          y1="22.8944"
          x2="204.988"
          y2="92.8797"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FED97A" />
          <stop offset="0.32" stopColor="#EBA04C" />
          <stop offset="0.58" stopColor="#EEB332" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1149_6563"
          x1="199.159"
          y1="23.9819"
          x2="204.811"
          y2="89.7322"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FED97A" />
          <stop offset="0.32" stopColor="#EBA04C" />
          <stop offset="0.58" stopColor="#EEB332" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1149_6563"
          x1="193.081"
          y1="42.1682"
          x2="199.217"
          y2="112.154"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FED97A" />
          <stop offset="0.32" stopColor="#EBA04C" />
          <stop offset="0.58" stopColor="#EEB332" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1149_6563"
          x1="193.388"
          y1="43.2558"
          x2="199.039"
          y2="109.006"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FED97A" />
          <stop offset="0.32" stopColor="#EBA04C" />
          <stop offset="0.58" stopColor="#EEB332" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1149_6563"
          x1="185.436"
          y1="63.0683"
          x2="191.571"
          y2="133.054"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FED97A" />
          <stop offset="0.32" stopColor="#EBA04C" />
          <stop offset="0.58" stopColor="#EEB332" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1149_6563"
          x1="185.745"
          y1="64.1559"
          x2="191.396"
          y2="129.906"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FED97A" />
          <stop offset="0.32" stopColor="#EBA04C" />
          <stop offset="0.58" stopColor="#EEB332" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_1149_6563"
          x1="178.853"
          y1="82.8944"
          x2="184.988"
          y2="152.88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FED97A" />
          <stop offset="0.32" stopColor="#EBA04C" />
          <stop offset="0.58" stopColor="#EEB332" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_1149_6563"
          x1="179.159"
          y1="83.9819"
          x2="184.811"
          y2="149.732"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FED97A" />
          <stop offset="0.32" stopColor="#EBA04C" />
          <stop offset="0.58" stopColor="#EEB332" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_1149_6563"
          x1="173.081"
          y1="102.168"
          x2="179.217"
          y2="172.154"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FED97A" />
          <stop offset="0.32" stopColor="#EBA04C" />
          <stop offset="0.58" stopColor="#EEB332" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_1149_6563"
          x1="173.388"
          y1="103.256"
          x2="179.039"
          y2="169.006"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FED97A" />
          <stop offset="0.32" stopColor="#EBA04C" />
          <stop offset="0.58" stopColor="#EEB332" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_1149_6563"
          x1="0.683421"
          y1="38.8703"
          x2="54.5831"
          y2="38.8703"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C1C1C1" />
          <stop offset="0.45" stopColor="#9D9D9D" />
          <stop offset="0.82" stopColor="#8C8C8C" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_1149_6563"
          x1="25.8287"
          y1="22.8944"
          x2="19.6934"
          y2="92.8797"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FED97A" />
          <stop offset="0.32" stopColor="#EBA04C" />
          <stop offset="0.58" stopColor="#EEB332" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_1149_6563"
          x1="25.5225"
          y1="23.9819"
          x2="19.8713"
          y2="89.7322"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FED97A" />
          <stop offset="0.32" stopColor="#EBA04C" />
          <stop offset="0.58" stopColor="#EEB332" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_1149_6563"
          x1="31.6004"
          y1="42.1682"
          x2="25.465"
          y2="112.154"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FED97A" />
          <stop offset="0.32" stopColor="#EBA04C" />
          <stop offset="0.58" stopColor="#EEB332" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_1149_6563"
          x1="31.2941"
          y1="43.2558"
          x2="25.6429"
          y2="109.006"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FED97A" />
          <stop offset="0.32" stopColor="#EBA04C" />
          <stop offset="0.58" stopColor="#EEB332" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_1149_6563"
          x1="39.246"
          y1="63.0683"
          x2="33.1107"
          y2="133.054"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FED97A" />
          <stop offset="0.32" stopColor="#EBA04C" />
          <stop offset="0.58" stopColor="#EEB332" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_1149_6563"
          x1="38.9367"
          y1="64.1559"
          x2="33.2855"
          y2="129.906"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FED97A" />
          <stop offset="0.32" stopColor="#EBA04C" />
          <stop offset="0.58" stopColor="#EEB332" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_1149_6563"
          x1="45.8288"
          y1="82.8944"
          x2="39.6935"
          y2="152.88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FED97A" />
          <stop offset="0.32" stopColor="#EBA04C" />
          <stop offset="0.58" stopColor="#EEB332" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_1149_6563"
          x1="45.5225"
          y1="83.9819"
          x2="39.8713"
          y2="149.732"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FED97A" />
          <stop offset="0.32" stopColor="#EBA04C" />
          <stop offset="0.58" stopColor="#EEB332" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_1149_6563"
          x1="51.6004"
          y1="102.168"
          x2="45.4651"
          y2="172.154"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FED97A" />
          <stop offset="0.32" stopColor="#EBA04C" />
          <stop offset="0.58" stopColor="#EEB332" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_1149_6563"
          x1="51.2941"
          y1="103.256"
          x2="45.6429"
          y2="169.006"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FED97A" />
          <stop offset="0.32" stopColor="#EBA04C" />
          <stop offset="0.58" stopColor="#EEB332" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_1149_6563"
          x1="70.0665"
          y1="96.3689"
          x2="70.0665"
          y2="180.338"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.67" stopColor="#E47B2E" />
          <stop offset="0.76" stopColor="#F19534" />
          <stop offset="0.85" stopColor="#FBA939" />
          <stop offset="0.91" stopColor="#FFB13B" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_1149_6563"
          x1="143.516"
          y1="139.239"
          x2="164"
          y2="139.239"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.54" stopColor="#E47B2E" />
          <stop offset="0.68" stopColor="#F19534" />
          <stop offset="0.81" stopColor="#FBA939" />
          <stop offset="0.91" stopColor="#FFB13B" />
        </linearGradient>
        <linearGradient
          id="paint24_linear_1149_6563"
          x1="153.67"
          y1="97.159"
          x2="153.67"
          y2="181.143"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.54" stopColor="#E47B2E" />
          <stop offset="0.68" stopColor="#F19534" />
          <stop offset="0.81" stopColor="#FBA939" />
          <stop offset="0.91" stopColor="#FFB13B" />
        </linearGradient>
        <linearGradient
          id="paint25_linear_1149_6563"
          x1="112.351"
          y1="94.5253"
          x2="112.351"
          y2="95.7105"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.25" stopColor="#771351" />
          <stop offset="0.64" stopColor="#DD1936" />
        </linearGradient>
        <linearGradient
          id="paint26_linear_1149_6563"
          x1="112.015"
          y1="103.231"
          x2="112.015"
          y2="201.642"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.68" stopColor="#E47B2E" />
          <stop offset="0.76" stopColor="#F19534" />
          <stop offset="0.85" stopColor="#FBA939" />
          <stop offset="0.91" stopColor="#FFB13B" />
        </linearGradient>
        <linearGradient
          id="paint27_linear_1149_6563"
          x1="72.8727"
          y1="21.8285"
          x2="151.9"
          y2="158.697"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FCE881" />
          <stop offset="0.31" stopColor="#FED65B" />
          <stop offset="0.64" stopColor="#FCC552" />
          <stop offset="1" stopColor="#F8C043" />
        </linearGradient>
        <linearGradient
          id="paint28_linear_1149_6563"
          x1="104.887"
          y1="29.0189"
          x2="122.347"
          y2="171.396"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFEDB1" />
          <stop offset="0.27" stopColor="#FEDF6B" />
          <stop offset="0.62" stopColor="#FDC727" />
          <stop offset="0.93" stopColor="#F39D50" />
        </linearGradient>
        <linearGradient
          id="paint29_linear_1149_6563"
          x1="40"
          y1="91.4899"
          x2="185"
          y2="91.4899"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC961" />
          <stop offset="1" stopColor="#FFE98B" />
        </linearGradient>
        <linearGradient
          id="paint30_linear_1149_6563"
          x1="73.9623"
          y1="23.5354"
          x2="151.361"
          y2="157.206"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0B335" />
          <stop offset="0.23" stopColor="#EEB854" />
          <stop offset="0.45" stopColor="#EFB550" />
          <stop offset="0.8" stopColor="#FFD06C" />
          <stop offset="1" stopColor="#FBEBBB" />
        </linearGradient>
        <linearGradient
          id="paint31_linear_1149_6563"
          x1="145.804"
          y1="166.292"
          x2="119.076"
          y2="28.9058"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF8F8" stopOpacity="0.46" />
          <stop offset="1" stopColor="#FFEBEB" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
  return (
    <svg
      className={className}
      width="100%"
      height="100%"
      viewBox="0 0 164 186"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M74.0035 181.099L74.003 181.099L10.5738 143.97L10.5735 143.969C5.74059 141.141 2.73333 135.892 2.73333 130.29V55.7073C2.73333 50.105 5.74059 44.8556 10.5735 42.0275L10.5738 42.0273L74.0023 4.89856C78.9382 2.01144 85.0702 2.01192 90.001 4.89805C90.0011 4.89808 90.0011 4.8981 90.0012 4.89812L153.426 42.0272L153.426 42.0274C158.259 44.8556 161.267 50.105 161.267 55.7073V130.29C161.267 135.895 158.256 141.141 153.426 143.97L90.001 181.099L90.0007 181.099C87.5338 182.544 84.7691 183.267 82.0021 183.267C79.2351 183.267 76.4704 182.544 74.0035 181.099Z"
        fill="url(#paint0_radial_1149_6761)"
        stroke="#C0B1E7"
        strokeWidth="5.46667"
      />
      <path
        d="M66.9119 32.0485V51.3694L88.0603 51.3069C89.6598 51.3069 90.8793 51.6921 91.8382 53.035C91.8728 53.0837 91.9228 53.1205 91.9603 53.1664C93.3222 54.8531 95.0457 55.5544 97.1039 55.4138C97.5569 55.3825 97.7156 55.2005 97.7089 54.7354L97.7118 51.6884C97.7271 51.1056 97.5396 50.8694 96.9779 50.8804L92.5913 50.9154C92.5913 50.9154 90.0493 50.6442 88.849 49.2645L88.3575 48.7406C87.1794 47.4427 85.7444 46.8122 84.0622 46.8159C82.2724 46.8195 80.4825 46.8168 78.6927 46.8177C75.9785 46.8177 72.9307 46.8067 70.2165 46.8287V43.8396C74.1425 43.8534 78.3281 43.8497 82.2551 43.8488C82.9033 43.8488 83.4554 44.0418 83.9093 44.495C84.3335 44.9178 84.7826 45.3176 85.2145 45.7349C86.332 46.814 87.6881 47.4142 89.278 47.4345C91.8757 47.4685 94.4744 47.4391 97.0722 47.4519C97.555 47.4538 97.7185 47.2543 97.7098 46.8223C97.6935 45.9647 97.705 45.1062 97.7031 44.2477C97.7012 43.4848 97.6906 43.4738 96.9039 43.4738C93.228 43.4738 89.5521 43.4719 85.8752 43.4738C83.213 43.4756 83.5265 43.6456 81.6588 41.8183C80.2796 40.469 78.66 39.7943 76.6595 39.8504C74.6215 39.9074 72.2565 39.8568 70.2156 39.8715V36.603H75.6342C76.2786 36.5928 76.796 36.8392 77.2404 37.3043C77.7645 37.853 78.2656 38.4275 78.7994 38.9652C79.8025 39.9763 80.9807 40.6234 82.3695 40.6308C87.2775 40.6565 92.1854 40.6409 97.0933 40.6537C97.5425 40.6547 97.7175 40.4699 97.7098 39.9938C97.6945 39.0195 97.7041 38.0451 97.7031 37.0708C97.7031 36.1461 97.6819 36.1222 96.8356 36.1222C91.0428 36.1222 85.2491 36.1351 79.4563 36.1176C76.2757 36.1084 77.0124 36.4789 74.7561 34.0311C73.5221 32.691 71.9573 32.0503 70.2184 32.0503L66.9119 32.0485Z"
        fill="#CCFF00"
      />
      <text
        x="84"
        y="110"
        fontSize="48"
        fontWeight="bold"
        textAnchor="middle"
        fill="white"
      >
        {xp}
      </text>
      <path
        d="M70.798 147.351H73.6632L76.4318 142.904H76.5197L79.3058 147.351H82.3292L78.2247 141.014V140.979L82.382 134.669H79.42L76.7394 139.239H76.6427L73.9445 134.669H70.8243L74.8322 140.935V140.962L70.798 147.351ZM83.8146 147.351H86.4689V143.352H88.9122C91.5841 143.352 93.3683 141.63 93.3683 139.019V139.002C93.3683 136.391 91.5841 134.669 88.9122 134.669H83.8146V147.351ZM88.2618 136.769C89.7823 136.769 90.6788 137.569 90.6788 139.01V139.028C90.6788 140.469 89.7823 141.278 88.2618 141.278H86.4689V136.769H88.2618Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_1149_6761"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(82 93) rotate(122.923) scale(166.506 146.874)"
        >
          <stop stopColor="#6332E0" />
          <stop offset="1" stopColor="#8162D0" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  )
}

export const GoldenBadgeLarge = memo(GoldenBadgeLargeComponent)
